const state = {
    userInfo: {

    },
    showTabbar: true,
    tabsIndex: 0,//消息选项卡
    EquipmentId:'',//Home设备编号
    HomeDesktop:[],//honme权限
    WarehouseList:[],//拥有权限的仓库列表
    ImgShow:true,//进入系统是否展示图片
    ClientInfo:{}, //app客户端信息
    supCollabShareVerifyCode:{}, //供应商协同校验码
}
export default state



// WEBPACK FOOTER //
// ./src/vuex/state.js